import { TotvsApiDatasource } from '../data/datasources/totvs-api.datasource';
import { TotvsRepositoryImpl } from '../data/repositories/totvs.repository.impl';

const api = new TotvsApiDatasource();
const repository = new TotvsRepositoryImpl(api);

export const totvsContainer = { repository };
